import { t } from '@lingui/macro';
import { Button, Chip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useUniversalSearch } from 'app/domains/global-search';
import { isUserAgent } from 'shared/domains/common-utils';
import { LauncherButtonContent, SearchPopupLauncherContainer } from './styled';
export function UniversalSearch() {
    const { openSearchPopup } = useUniversalSearch();
    const shortcutLabelMac = t({
        message: '⌘K',
        comment: 'Universal search popup shortcut label for mac: ⌘k',
    });
    const shortcutLabelNonMac = t({
        message: 'Ctrl+k',
        comment: 'Universal search popup shortcut label for non mac: Ctrl+K',
    });
    const shortcutLabel = isUserAgent('mac') ? shortcutLabelMac : shortcutLabelNonMac;
    return (<SearchPopupLauncherContainer>
      <Button onClick={openSearchPopup} appearance="secondary" $stretch>
        <LauncherButtonContent>
          <Falcon icon="search"/>
          {t({
            message: 'Search',
            comment: 'Search input placeholder',
        })}
        </LauncherButtonContent>
        <Chip label={shortcutLabel} appearance="secondary"/>
      </Button>
    </SearchPopupLauncherContainer>);
}
